import { CSSProperties } from 'react'
import classNames from 'classnames/bind'

import styles from './days-grid-item.module.scss'

const cx = classNames.bind(styles)

type Props = {
  day: number
  dateTimeFormatted: string
  today: boolean
  holyday: boolean
  selected: boolean
  outrange: boolean
  disabled: boolean
  dateFormat: string
  mark?: boolean
  getMarkColor?: (dayFarmatted: string, format: string) => string | undefined
  onClick: (dayFarmatted: string, format: string) => void
}

const DaysGridItem = ({
  day,
  dateTimeFormatted,
  today,
  holyday,
  selected,
  outrange,
  disabled,
  dateFormat,
  mark,
  getMarkColor,
  onClick,
}: Props) => {
  const handleDayClick = () => {
    onClick(dateTimeFormatted, dateFormat)
  }

  const markColor = getMarkColor && getMarkColor(dateTimeFormatted, dateFormat)

  return (
    <button
      type="button"
      onClick={handleDayClick}
      disabled={disabled}
      className={cx(styles.root, {
        today,
        selected,
        holyday,
        outrange,
        disabled,
        mark,
      })}
      style={markColor ? ({ '--mark-color': markColor } as CSSProperties) : undefined}
    >
      <time dateTime={dateTimeFormatted}>{day}</time>
    </button>
  )
}

export default DaysGridItem
